import { Grid, Tab, Tabs } from "@mui/material"
import { StaticDataAccordion } from "../../Component/Common/Components/Accordion/StaticDataAccordion";
import { EELegislation } from "../../Component/Common/Constants/StaticPageConstants/EELegislation";
import "./Legislation.css"
import { LegislationService } from "../../Component/Api/Legislation/LegislationService";
import { urltoFile } from "../../Component/Model/helpers";
import { ModuleType } from "../../Component/Model/Enum/BEE123Enums";
import { Link, Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { EEResourceTemplates } from "../../Component/Common/Constants/StaticPageConstants/EEResourceTemplates";

const followLink = async (link: string | undefined, section: number | undefined) => {
    if (link && section) {
        try {
            const result = await LegislationService.GetLegislationDocument(
                link, 
                ModuleType.Employment_Equity_Module, 
                section
            );
              
            const file = await urltoFile(
                'data:text/plain;base64,' + result.data.fileContents, 
                link, 
                result.data.contentType
            );
            
            const url = URL.createObjectURL(file);
            const documentLink = document.createElement("a");
            
            documentLink.setAttribute("href", url);
            documentLink.setAttribute("download", result.data.fileDownloadName || link);
            document.body.appendChild(documentLink);
            documentLink.click();
            document.body.removeChild(documentLink);
        } catch (error) {
            console.log(error);
        }
    }
};


const RenderPage = ({ data }: { data: any[] }) => {
    return (
        <Grid container style={{ padding: "15px" }}>
            <Grid item xs={12} lg={12} mt={2}>
                {data.map((item, index) => (
                    <StaticDataAccordion key={index} {...item} followLink={followLink} />
                ))}
            </Grid>
        </Grid>
    );
};

export const EELegislationResourcesPage = () => {
    const routes = [
        "/legislation/EE/Legislation",
        "/legislation/EE/ResourceTemplates",
    ];

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;
    const currentTabIndex = routes.findIndex(route => route === currentTab);
    
    return (
        <Grid container>
            <Grid item xs={12}>
                <Tabs value={currentTab} aria-label="Tabs" centered>
                    <Tab label="Employment Equity Legislation" value={routes[0]} to={routes[0]} component={Link} />
                    <Tab label="Employment Equity Resource Templates" value={routes[1]} to={routes[1]} component={Link}/>
                </Tabs>
            </Grid>

            <Grid item xs={12} mt={3}>
                {currentTabIndex === -1 ? <Redirect to={routes[0]} /> : null}
                <Switch>
                    <Route path={routes[0]}>
                        <RenderPage data={EELegislation} />
                    </Route>
                    <Route path={routes[1]}>
                        <RenderPage data={EEResourceTemplates} />
                    </Route>
                </Switch>
            </Grid>
        </Grid>
    );
};